// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__20VLo","detailsBorder":"styles_detailsBorder__3xs36"};